import type { LocalizationProviderProps } from '@mui/x-date-pickers';
import type { DateTime } from 'luxon';

/**
 * Copy for the date picker's own chrome.
 *
 * MUI ships these labels in English. The shell is the only place that knows the reader's
 * language, so they are resolved here and handed to the adapter as `localeText`.
 */
const PICKER_LOCALE_KEYS = {
  cancelButtonLabel: 'common:cancel',
  okButtonLabel: 'common:ok',
  todayButtonLabel: 'common:dateRange.today',
  datePickerToolbarTitle: 'common:selectDate',
} as const;

type PickerLocaleKey =
  (typeof PICKER_LOCALE_KEYS)[keyof typeof PICKER_LOCALE_KEYS];

export type PickerLocaleMessages = Record<PickerLocaleKey, string>;

/**
 * Maps shell translations onto the MUI picker labels the calendar actually renders.
 * @param translations - Resolved copy for the four picker strings
 * @returns The `localeText` slice the date adapter expects
 */
export const pickerLocaleText = <T extends PickerLocaleMessages>(
  translations: T
): LocalizationProviderProps<DateTime, string>['localeText'] => ({
  cancelButtonLabel: translations[PICKER_LOCALE_KEYS.cancelButtonLabel],
  okButtonLabel: translations[PICKER_LOCALE_KEYS.okButtonLabel],
  todayButtonLabel: translations[PICKER_LOCALE_KEYS.todayButtonLabel],
  datePickerToolbarTitle:
    translations[PICKER_LOCALE_KEYS.datePickerToolbarTitle],
});
